import { toast } from 'react-toastify'
import ToastMessage, {
  ToastMessageProps,
} from '@components/molecules/ToastMessage'

const useToaster = () => {
  const toaster = (props: ToastMessageProps) => {
    return toast(
      ({ closeToast, toastProps }) => (
        <ToastMessage
          closeToast={closeToast}
          toastProps={toastProps}
          {...props}
        />
      ),
      props?.options
    )
  }

  const toastPromise = (
    promise: Promise<void>,
    messages: {
      pending: string
      success: {
        text: string
        action?: () => void
      }
      error: {
        text: string
        action?: () => void
      }
    }
  ) => {
    return toast.promise(promise, {
      pending: {
        render({ closeToast, toastProps }) {
          return (
            <ToastMessage
              closeToast={closeToast}
              toastProps={toastProps}
              title={messages.pending}
              type="pending"
            />
          )
        },
        icon: false,
      },
      success: {
        render({ closeToast, toastProps }) {
          if (messages.success.action) messages.success.action()
          return (
            <ToastMessage
              closeToast={closeToast}
              toastProps={toastProps}
              title={messages.success.text}
              type="success"
            />
          )
        },
      },
      error: {
        render({ closeToast, toastProps }) {
          if (messages.error.action) messages.error.action()
          return (
            <ToastMessage
              closeToast={closeToast}
              toastProps={toastProps}
              title={messages.error.text}
              type="error"
            />
          )
        },
      },
    })
  }

  return { toaster, toastPromise }
}

export { useToaster }
